import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-template-sms-list',
  standalone: false,
  templateUrl: './notification-template-sms-list.component.html',
  styleUrl: './notification-template-sms-list.component.scss'
})
export class NotificationTemplateSmsListComponent {

}
